import { mapGetters } from 'vuex'

export default {
  ...mapGetters(['user']),
  getMessageConfirmation () {
    return {
      cancel: 'Cancelar',
      label: 'Remover',
      title: 'Confirmar Remoção',
      message: `Deseja remover esta bicicleta?`
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/tenant/bike/resources/computed.js